// src/api/promoApi.js
import axios from 'axios';



export const getAllPromos = () => axios.get(`${process.env.REACT_APP_PROMO_BASE}/all`);
export const createPromo = (promo) => axios.post(`${process.env.REACT_APP_PROMO_BASE}/create`, promo);
export const updatePromo = (id, promo) => axios.put(`${process.env.REACT_APP_PROMO_BASE}/update/${id}`, promo);
export const deletePromo = (id) => axios.delete(`${process.env.REACT_APP_PROMO_BASE}/delete/${id}`);
export const searchPromos = (params) => axios.get(`${process.env.REACT_APP_PROMO_BASE}/search`, { params });
export const uploadCsv = (type, file) => {
  const formData = new FormData();
  formData.append("type", type);
 
  formData.append("file", file, file.name);


  return axios.post(`${process.env.REACT_APP_PROMO_BASE}/upload-csv`, formData);
};
export const validatePromo = (code) =>
  axios.get(`${process.env.REACT_APP_PROMO_BASE}/isUniqueCode/${encodeURIComponent(code)}`);

export const getZones = () =>
  axios.get(`${process.env.REACT_APP_CART_BASE}/zones`);

export const getCircles = (zoneId) =>
  axios.get(`${process.env.REACT_APP_CART_BASE}/circles`, { params: { zoneId } });


export const getClusters = (circleCodes = []) =>
  axios.get(`${process.env.REACT_APP_CART_BASE}/clusters`, {
    params: { circleCode: circleCodes.join(',') }
  });


export const getClinics = (clusterCodes = []) =>
  axios.get(`${process.env.REACT_APP_CART_BASE}/locations`, {
    params: { clusterId: clusterCodes.join(',') }
  });

